// @flow
import React, { Component } from 'react';
import { findIndex } from 'lodash';
import { range } from '../../../helpers/utils';
import InfiniteSelect from './InfiniteSelect';

import '../../../../static/scss/components/timeWheelSelect.scss';

const calculateIndex = (array, index) => (array.length + index) % array.length;

const findMinuteIndex = (minutes, min, minuteStep) =>
  findIndex(minutes, obj => obj.value === min - (min % minuteStep));

const mapHourRange = () =>
  range(0, 24).map(i => ({
    value: i,
    label: `0${i}`.substr(-2)
  }));
const mapMinuteRange = minuteStep =>
  range(0, 60, minuteStep).map(i => ({
    value: i,
    label: `0${i}`.substr(-2)
  }));
const minuteStep = 5;

type Props = {
  type: string,
  callback: (...args: Array<any>) => any,
  value: string,
  syncValueFromProps?: boolean
};

type State = {
  hour: {
    index: number
  },
  minute: {
    index: number
  }
};

class TimeWheelSelect extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    // Set the initial hour depending on the time of day
    const parts = props.value.split(':');
    const hour = Number(parts[0]);
    const min = Number(parts[1]);

    this.hours = mapHourRange();
    this.minutes = mapMinuteRange(minuteStep);

    this.state = {
      hour: {
        index: findIndex(this.hours, obj => obj.value === hour)
      },
      minute: {
        index: findMinuteIndex(this.minutes, min, minuteStep)
      }
    };
  }

  componentDidUpdate() {
    /* eslint-disable react/no-did-update-set-state */
    if (this.props.syncValueFromProps) {
      const parts = this.props.value.split(':');
      const hour = Number(parts[0]);
      const min = Number(parts[1]);

      const hours = mapHourRange();
      const minutes = mapMinuteRange(minuteStep);
      const hourIndex = findIndex(hours, obj => obj.value === hour);
      const minuteIndex = findMinuteIndex(minutes, min, minuteStep);

      if (hourIndex !== this.state.hour.index) {
        this.setState({ hour: { index: hourIndex } });
      }

      if (minuteIndex !== this.state.minute.index) {
        this.setState({ minute: { index: minuteIndex } });
      }
    }
  }

  handleSelectChange(time, arr, selectedOption) {
    const { value } = selectedOption;
    const index = findIndex(arr, obj => obj.value === value);

    this.applyChange(time, value, index);
  }

  handleValueChange(time, arr, index, value) {
    const updatedIndex = calculateIndex(arr, index + value);
    const updatedValue = arr[updatedIndex].value;

    this.applyChange(time, updatedValue, updatedIndex);
  }

  applyChange(time, value, index) {
    const { type, callback } = this.props;

    this.setState(
      {
        [time]: { index }
      },
      () => {
        callback.apply(this, [type.toLowerCase(), time, value]);
      }
    );
  }

  render() {
    const { index: hourIndex } = this.state.hour;
    const { index: minuteIndex } = this.state.minute;

    return (
      <div className="c-timeWheelSelect">
        <div className="react-select__container">
          <button
            type="button"
            onClick={() =>
              this.handleValueChange('hour', this.hours, hourIndex, -1)
            }
            className="react-select__button react-select__button--up"
            aria-label="add one hour"
          />
          <InfiniteSelect
            values={this.hours}
            value={this.hours[hourIndex].value}
            onChange={selectedOption =>
              this.handleSelectChange('hour', this.hours, selectedOption)
            }
          />
          <button
            type="button"
            onClick={() =>
              this.handleValueChange('hour', this.hours, hourIndex, 1)
            }
            className="react-select__button react-select__button--down"
            aria-label="subtract one hour"
          />
        </div>
        <div className="react-select__container">
          <button
            type="button"
            onClick={() =>
              this.handleValueChange('minute', this.minutes, minuteIndex, -1)
            }
            className="react-select__button react-select__button--up"
            aria-label="add one minute"
          />{' '}
          <InfiniteSelect
            values={this.minutes}
            value={this.minutes[minuteIndex].value}
            onChange={selectedOption =>
              this.handleSelectChange('minute', this.minutes, selectedOption)
            }
            hiddenItems={3}
          />
          <button
            type="button"
            onClick={() =>
              this.handleValueChange('minute', this.minutes, minuteIndex, 1)
            }
            className="react-select__button react-select__button--down"
            aria-label="subtract one minute"
          />
        </div>
      </div>
    );
  }
}

TimeWheelSelect.defaultProps = {
  syncValueFromProps: true
};

export default TimeWheelSelect;
